import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Logo from './Logo';
import '../assets/css/Nav.css';
import ukFlag from '../assets/image/uk.png';
import saudiFlag from '../assets/image/saudi-arabia.png';

function Nav() {
    const { language } = useLanguage();
    const navigate = useNavigate();
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    const switchLanguage = () => {
        const newLang = language === 'en' ? 'ar' : 'en';
        // Get current path without language prefix
        const currentPath = location.pathname.replace(/^\/[a-z]{2}/, '') || '';
        // Navigate to the same page with new language
        navigate(`/${newLang}${currentPath}`);
        setIsMenuOpen(false); // Close menu after language switch
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    // Close menu when clicking outside
    React.useEffect(() => {
        const handleClickOutside = (event) => {
            if (isMenuOpen && !event.target.closest('.nav_menu_container')) {
                setIsMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isMenuOpen]);

    return (
        <div>
            <nav className="nav_wrap">
                <div className="nav_contain">
                    <div className="nav_layout u-hflex-between-center">
                        <a href="/" aria-current="page" className="nav_logo_link w-inline-block w--current">
                            <Logo className='logo1Nav' />
                        </a>
                        <div className="nav_actions_wrap u-hflex-right-stretch">
                            {/* Login Button - Desktop Only */}
                            <a 
                                href={`https://audiosum.app/login?lang=${language}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="login_button desktop-only"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    padding: '10px 20px',
                                    marginRight: '12px',
                                    background: 'linear-gradient(135deg, rgba(177, 74, 255, 0.1), rgba(177, 74, 255, 0.05))',
                                    border: '2px solid rgba(177, 74, 255, 0.8)',
                                    borderRadius: '50px',
                                    color: '#ffffff',
                                    textDecoration: 'none',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 4px 15px rgba(177, 74, 255, 0.2)',
                                    letterSpacing: '0.3px',
                                    whiteSpace: 'nowrap'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.borderColor = 'rgba(177, 74, 255, 1)';
                                    e.target.style.background = 'linear-gradient(135deg, rgba(177, 74, 255, 0.2), rgba(177, 74, 255, 0.1))';
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 8px 25px rgba(177, 74, 255, 0.3)';
                                    e.target.style.color = 'rgba(177, 74, 255, 1)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.borderColor = 'rgba(177, 74, 255, 0.8)';
                                    e.target.style.background = 'linear-gradient(135deg, rgba(177, 74, 255, 0.1), rgba(177, 74, 255, 0.05))';
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 4px 15px rgba(177, 74, 255, 0.2)';
                                    e.target.style.color = '#ffffff';
                                }}
                                onMouseDown={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 4px 15px rgba(177, 74, 255, 0.2)';
                                }}
                            >
                                <svg 
                                    width="16" 
                                    height="16" 
                                    viewBox="0 0 24 24" 
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                                    <polyline points="10,17 15,12 10,7"/>
                                    <line x1="15" y1="12" x2="3" y2="12"/>
                                </svg>
                                {language === 'ar' ? 'تسجيل الدخول' : 'Login'}
                            </a>

                            {/* Menu Button Container */}
                            <div className="nav_menu_container" style={{ position: 'relative' }}>
                                {/* Menu Button */}
                                <button 
                                    onClick={toggleMenu}
                                    className="menu_button responsive-menu-btn"
                                    onMouseEnter={(e) => {
                                        e.target.style.borderColor = 'rgba(177, 74, 255, 1)';
                                        e.target.style.background = 'linear-gradient(135deg, rgba(177, 74, 255, 0.2), rgba(177, 74, 255, 0.1))';
                                        e.target.style.transform = 'translateY(-2px)';
                                        e.target.style.boxShadow = '0 8px 25px rgba(177, 74, 255, 0.3)';
                                        e.target.style.color = 'rgba(177, 74, 255, 1)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.borderColor = 'rgba(177, 74, 255, 0.8)';
                                        e.target.style.background = 'linear-gradient(135deg, rgba(177, 74, 255, 0.1), rgba(177, 74, 255, 0.05))';
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = '0 4px 15px rgba(177, 74, 255, 0.2)';
                                        e.target.style.color = '#ffffff';
                                    }}
                                    onMouseDown={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = '0 4px 15px rgba(177, 74, 255, 0.2)';
                                    }}
                                >
                                    <svg 
                                        width="20" 
                                        height="20" 
                                        viewBox="0 0 24 24" 
                                        fill="none" 
                                        style={{ 
                                            transform: isMenuOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                                            transition: 'transform 0.3s ease'
                                        }}
                                    >
                                        <path d="M3 12H21" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
                                        <path d="M3 6H21" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
                                        <path d="M3 18H21" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
                                    </svg>
                                </button>

                                {/* Dropdown Menu */}
                                {isMenuOpen && (
                                    <div 
                                        className="dropdown_menu"
                                        style={{
                                            position: 'absolute',
                                            top: '100%',
                                            right: '0',
                                            marginTop: '12px',
                                            background: 'linear-gradient(135deg, rgba(30, 41, 59, 0.95), rgba(51, 65, 85, 0.9))',
                                            backdropFilter: 'blur(15px)',
                                            borderRadius: '20px',
                                            boxShadow: '0 20px 40px rgba(177, 74, 255, 0.15), 0 0 0 1px rgba(177, 74, 255, 0.1)',
                                            border: '2px solid rgba(177, 74, 255, 0.2)',
                                            minWidth: '260px',
                                            zIndex: 1000,
                                            overflow: 'hidden',
                                            animation: 'dropdownFade 0.3s ease-out'
                                        }}
                                    >
                                        {/* Launch App */}
                                        <a 
                                            href={`https://audiosum.app/signup?lang=${language}`}
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '14px',
                                                padding: '18px 24px',
                                                textDecoration: 'none',
                                                color: '#e2e8f0',
                                                fontSize: '15px',
                                                fontWeight: '600',
                                                borderBottom: '1px solid rgba(177, 74, 255, 0.3)',
                                                transition: 'all 0.2s ease',
                                                letterSpacing: '0.3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(177, 74, 255, 0.2), rgba(177, 74, 255, 0.1))';
                                                e.target.style.color = 'rgba(177, 74, 255, 1)';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'transparent';
                                                e.target.style.color = '#e2e8f0';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                            onClick={() => setIsMenuOpen(false)}
                                        >
                                            <img 
                                                src="/logo.png" 
                                                alt="Audiosum Logo" 
                                                style={{ 
                                                    width: '20px', 
                                                    height: '20px', 
                                                    borderRadius: '4px',
                                                    filter: 'brightness(1.1) contrast(1.1)',
                                                    objectFit: 'contain'
                                                }} 
                                            />
                                            {language === 'ar' ? 'تشغيل التطبيق' : 'Launch App'}
                                        </a>

                                        {/* Login - Mobile Menu Only */}
                                        <a 
                                            href={`https://audiosum.app/login?lang=${language}`}
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '14px',
                                                padding: '18px 24px',
                                                textDecoration: 'none',
                                                color: '#e2e8f0',
                                                fontSize: '15px',
                                                fontWeight: '600',
                                                borderBottom: '1px solid rgba(177, 74, 255, 0.3)',
                                                transition: 'all 0.2s ease',
                                                letterSpacing: '0.3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(177, 74, 255, 0.2), rgba(177, 74, 255, 0.1))';
                                                e.target.style.color = 'rgba(177, 74, 255, 1)';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'transparent';
                                                e.target.style.color = '#e2e8f0';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                            onClick={() => setIsMenuOpen(false)}
                                        >
                                            <svg 
                                                width="20" 
                                                height="20" 
                                                viewBox="0 0 24 24" 
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                                                <polyline points="10,17 15,12 10,7"/>
                                                <line x1="15" y1="12" x2="3" y2="12"/>
                                            </svg>
                                            {language === 'ar' ? 'تسجيل الدخول' : 'Login'}
                                        </a>

                                        {/* Home */}
                                        <a 
                                            href={`/${language}`}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '14px',
                                                padding: '18px 24px',
                                                textDecoration: 'none',
                                                color: '#e2e8f0',
                                                fontSize: '15px',
                                                fontWeight: '600',
                                                borderBottom: '1px solid rgba(177, 74, 255, 0.3)',
                                                transition: 'all 0.2s ease',
                                                letterSpacing: '0.3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(177, 74, 255, 0.2), rgba(177, 74, 255, 0.1))';
                                                e.target.style.color = 'rgba(177, 74, 255, 1)';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'transparent';
                                                e.target.style.color = '#e2e8f0';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                            onClick={() => setIsMenuOpen(false)}
                                        >
                                            <svg 
                                                width="20" 
                                                height="20" 
                                                viewBox="0 0 24 24" 
                                                fill="none" 
                                                stroke="currentColor" 
                                                strokeWidth="2" 
                                                strokeLinecap="round" 
                                                strokeLinejoin="round"
                                            >
                                                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                                                <polyline points="9,22 9,12 15,12 15,22"/>
                                            </svg>
                                            {language === 'ar' ? 'الرئيسية' : 'Home'}
                                        </a>

                                        {/* How It Works - Temporarily Hidden */}
                                        {/* <a 
                                            href={`/${language}/watch-demo`}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '14px',
                                                padding: '18px 24px',
                                                textDecoration: 'none',
                                                color: '#e2e8f0',
                                                fontSize: '15px',
                                                fontWeight: '600',
                                                borderBottom: '1px solid rgba(177, 74, 255, 0.3)',
                                                transition: 'all 0.2s ease',
                                                letterSpacing: '0.3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(177, 74, 255, 0.2), rgba(177, 74, 255, 0.1))';
                                                e.target.style.color = 'rgba(177, 74, 255, 1)';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'transparent';
                                                e.target.style.color = '#e2e8f0';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                            onClick={() => setIsMenuOpen(false)}
                                        >
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <polygon points="5,3 19,12 5,21" fill="currentColor"/>
                                            </svg>
                                            {language === 'ar' ? 'كيف يعمل' : 'How it Works'}
                                        </a> */}



                                        {/* About Us */}
                                        <a 
                                            href={`/${language}/about`}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '14px',
                                                padding: '18px 24px',
                                                textDecoration: 'none',
                                                color: '#e2e8f0',
                                                fontSize: '15px',
                                                fontWeight: '600',
                                                borderBottom: '1px solid rgba(177, 74, 255, 0.3)',
                                                transition: 'all 0.2s ease',
                                                letterSpacing: '0.3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(177, 74, 255, 0.2), rgba(177, 74, 255, 0.1))';
                                                e.target.style.color = 'rgba(177, 74, 255, 1)';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'transparent';
                                                e.target.style.color = '#e2e8f0';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                            onClick={() => setIsMenuOpen(false)}
                                        >
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            {language === 'ar' ? 'عن الشركة' : 'About Us'}
                                        </a>

                                        {/* Pricing */}
                                        <a 
                                            href={`/${language}/pricing`}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '14px',
                                                padding: '18px 24px',
                                                textDecoration: 'none',
                                                color: '#e2e8f0',
                                                fontSize: '15px',
                                                fontWeight: '600',
                                                borderBottom: '1px solid rgba(177, 74, 255, 0.3)',
                                                transition: 'all 0.2s ease',
                                                letterSpacing: '0.3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(177, 74, 255, 0.2), rgba(177, 74, 255, 0.1))';
                                                e.target.style.color = 'rgba(177, 74, 255, 1)';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'transparent';
                                                e.target.style.color = '#e2e8f0';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                            onClick={() => setIsMenuOpen(false)}
                                        >
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <path d="M12 1V23" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6312 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6312 13.6815 18 14.5717 18 15.5C18 16.4283 17.6312 17.3185 16.9749 17.9749C16.3185 18.6312 15.4283 19 14.5 19H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            {language === 'ar' ? 'الأسعار' : 'Pricing'}
                                        </a>

                                        {/* Contact */}
                                        <a 
                                            href={`/${language}/contact`}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '14px',
                                                padding: '18px 24px',
                                                textDecoration: 'none',
                                                color: '#e2e8f0',
                                                fontSize: '15px',
                                                fontWeight: '600',
                                                borderBottom: '1px solid rgba(177, 74, 255, 0.3)',
                                                transition: 'all 0.2s ease',
                                                letterSpacing: '0.3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(177, 74, 255, 0.2), rgba(177, 74, 255, 0.1))';
                                                e.target.style.color = 'rgba(177, 74, 255, 1)';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'transparent';
                                                e.target.style.color = '#e2e8f0';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                            onClick={() => setIsMenuOpen(false)}
                                        >
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M8 9H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                <path d="M8 13H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                            </svg>
                                            {language === 'ar' ? 'اتصل بنا' : 'Contact'}
                                        </a>

                                        {/* Terms of Service */}
                                        <a 
                                            href={`/${language}/terms-of-service`}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '14px',
                                                padding: '18px 24px',
                                                textDecoration: 'none',
                                                color: '#e2e8f0',
                                                fontSize: '15px',
                                                fontWeight: '600',
                                                borderBottom: '1px solid rgba(177, 74, 255, 0.3)',
                                                transition: 'all 0.2s ease',
                                                letterSpacing: '0.3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(177, 74, 255, 0.2), rgba(177, 74, 255, 0.1))';
                                                e.target.style.color = 'rgba(177, 74, 255, 1)';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'transparent';
                                                e.target.style.color = '#e2e8f0';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                            onClick={() => setIsMenuOpen(false)}
                                        >
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                            </svg>
                                            {language === 'ar' ? 'شروط الخدمة' : 'Terms of Service'}
                                        </a>

                                        {/* Privacy Policy */}
                                        <a 
                                            href={`/${language}/privacy-policy`}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '14px',
                                                padding: '18px 24px',
                                                textDecoration: 'none',
                                                color: '#e2e8f0',
                                                fontSize: '15px',
                                                fontWeight: '600',
                                                borderBottom: '1px solid rgba(177, 74, 255, 0.3)',
                                                transition: 'all 0.2s ease',
                                                letterSpacing: '0.3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(177, 74, 255, 0.2), rgba(177, 74, 255, 0.1))';
                                                e.target.style.color = 'rgba(177, 74, 255, 1)';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'transparent';
                                                e.target.style.color = '#e2e8f0';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                            onClick={() => setIsMenuOpen(false)}
                                        >
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <path d="M12 22S8 18 8 14V5L12 3L16 5V14C16 18 12 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            {language === 'ar' ? 'سياسة الخصوصية' : 'Privacy Policy'}
                                        </a>

                                        {/* Language Switcher */}
                                        <button 
                                            onClick={switchLanguage}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '14px',
                                                padding: '18px 24px',
                                                background: 'none',
                                                border: 'none',
                                                color: '#e2e8f0',
                                                fontSize: '15px',
                                                fontWeight: '600',
                                                cursor: 'pointer',
                                                width: '100%',
                                                textAlign: 'left',
                                                transition: 'all 0.2s ease',
                                                letterSpacing: '0.3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(177, 74, 255, 0.2), rgba(177, 74, 255, 0.1))';
                                                e.target.style.color = 'rgba(177, 74, 255, 1)';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'transparent';
                                                e.target.style.color = '#e2e8f0';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                        >
                                            <img 
                                                src={language === 'en' ? saudiFlag : ukFlag} 
                                                alt={language === 'en' ? 'Arabic' : 'English'} 
                                                style={{ width: '18px', height: '13px', borderRadius: '2px' }}
                                            />
                                            {language === 'ar' ? 'English' : 'العربية'}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            
        </div>

    )
}

export default Nav
